import React, { FC } from 'react';
import Styles from './index.module.less';
import classNames from 'classnames';

interface PreviewVideoCardProps {
  highlightDirection: 'left' | 'right' | 'top' | 'bottom';
  url: string;
  loop: boolean;
}

const Direction2ClassNameMap: Record<PreviewVideoCardProps['highlightDirection'], string> = {
  left: 'highlight-left',
  right: 'highlight-right',
  top: 'highlight-top',
  bottom: 'highlight-bottom',
};

export const PreviewVideoCard: FC<PreviewVideoCardProps> = (props) => {
  const { url, loop, highlightDirection } = props;

  return (
    <div
      className={classNames(
        Styles['preview-video-card'],
        Styles[Direction2ClassNameMap[highlightDirection]],
      )}
    >
      <video
        width='100%'
        height='100%'
        muted
        loop={loop}
        autoPlay
        style={{ borderRadius: '0.75rem', objectFit: 'fill' }}
      >
        <source src={url} type='video/mp4'></source>
        video load failed
      </video>
    </div>
  );
};
